<div class="filter-dropdowns-wrapper">
  <form [formGroup]="filterForm" class="filter-form">
    <div class="dropdowns-row">
      <div class="dropdown-group">
        <label for="productId">Program:</label>
        <p-select
          inputId="productId"
          formControlName="productId"
          [options]="programs"
          optionLabel="label"
          optionValue="value"
          placeholder="Select Program"
          styleClass="dropdown-select">
        </p-select>
      </div>
      <div class="dropdown-group">
        <label for="tenantId">Tenant:</label>
        <p-select
          inputId="tenantId"
          formControlName="tenantId"
          [options]="tenants"
          optionLabel="label"
          optionValue="value"
          placeholder="Select Tenant"
          [disabled]="!filterForm.get('productId')?.value"
          styleClass="dropdown-select">
        </p-select>
      </div>
      <div class="dropdown-group">
        <label for="overrideTypeId">Plan:</label>
        <p-select
          inputId="overrideTypeId"
          formControlName="overrideTypeId"
          [options]="plans"
          optionLabel="label"
          optionValue="value"
          placeholder="Select Plan"
          [disabled]="!filterForm.get('tenantId')?.value"
          styleClass="dropdown-select-wide">
        </p-select>
      </div>
    </div>
  </form>
</div>
